module.exports = __webpack_public_path__ + "img/skipping-rope.7a0bf845.svg";